import { Home, Briefcase, Heart, Cpu, PenTool, Shield, DollarSign, Umbrella } from 'react-feather';

export const HELP_WITH_FILTERS = [
    { key: 1, text: "Saving Up For A House", icon: "/buying-home.png" },
    { key: 2, text: "Supporting My Parents", icon: "/supporting-parents.png" },
    { key: 3, text: "Single Parent Finances", icon: "/single-parent.png" },
    { key: 4, text: "Navigating Divorce", icon: "/divorce.png" },
    { key: 5, text: "Managing Debt", icon: "/debt.png" },
    { key: 6, text: "Equity Compensation", icon: "/equity-compensation.png" },
    { key: 7, text: "Real Estate Investing", icon: "/real-estate-investing.png" },
    { key: 8, text: "Education Cost Planning", icon: "/education-savings.png" },
    { key: 9, text: "Financial Windfall", icon: "/inheritance.png" }
];

export const INDUSTRY_MAPPINGS = [
    { key: 1, text: "Real Estate", icon: 'home' },
    { key: 2, text: "Business", icon: 'briefcase' },
    { key: 3, text: "Healthcare", icon: 'heart' },
    { key: 4, text: "Tech", icon: 'cpu' },
    { key: 5, text: "Legal", icon: 'pentool' },
    { key: 6, text: "Military", icon: 'shield' },
    { key: 7, text: "Finance", icon: 'dollarsign' },
    { key: 8, text: "Other", icon: 'umbrella' }
];

export const ICON_MAPPINGS = [
    { key: "home", icon: <Home size={20} /> },
    { key: "briefcase", icon: <Briefcase size={20} /> },
    { key: "heart", icon: <Heart size={20} /> },
    { key: "cpu", icon: <Cpu size={20} /> },
    { key: "pentool", icon: <PenTool size={20} /> },
    { key: "shield", icon: <Shield size={20} /> },
    { key: "dollarsign", icon: <DollarSign size={20} /> },
    { key: "umbrella", icon: <Umbrella size={20} /> }
]

export const LIFESTAGE_MAPPINGS = [
    { key: 1, text: "Early Career" },
    { key: 2, text: "Mid-Career" },
    { key: 3, text: "Pre-Retirement" },
    { key: 4, text: "Young Family" },
    { key: 5, text: "Empty Nesters" },
    { key: 6, text: "Retirement" }
];